import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AgencyMasterService } from '../../services/agency-master/agency-master.service';
import { RatesSroMasterService } from '../../services/rates-sro-master/rates-sro-master.service';
import { RatesSroOriginDestinationService } from '../../services/rates-sro-origin-destination/rates-sro-origin-destination.service';
import { CustomerOrganization } from '../agencytspsearch/agencytspsearch';
import { LoadingService } from '../../services/loading/loading.service';
import {ColDef, ColGroupDef, GridApi, GridOptions} from 'ag-grid-community';
import 'ag-grid-enterprise';
import { ButtonRendererComponent } from '../frt-rates-download/ButtonRendererComponent';
import {
  AgencyMaster,
  RatesSroMaster,
  RatesSroOriginDestination,
  RateTypesSro,
  RateTypes,
  StateCountry,
  FrtAcessorialsMaster
} from '../../shared/common-components/common-structure';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { AlertService } from '../../services/alert/alert.service';
import { HhgCarrierRateFilingService } from '../hhg-carrier-rate-filing/hhg-carrier-rate-filing.service';
import { ConfirmationModalComponent } from 'src/app/shared/common-components/confirmation-modal/confirmation-modal.component';
import { StateCountryService } from 'src/app/services/state-country/state-country.service';
import { Observable } from 'rxjs';
import { delay } from 'q';
import AppConstants from '../../shared/common-components/AppConstants';

@Component({
    selector: 'app-rates-sro-maintenance',
    templateUrl: './rates-sro-maintenance.component.html',
    styleUrls: ['./rates-sro-maintenance.component.css'],
    standalone: false
})
export class RatesSroMaintenanceComponent implements OnInit {
  // Declared variables
  gridOptions: GridOptions = this.initializeGridOptions();
  private gridApi!: GridApi<any>;
  frameworkComponents: any;
  agencyCustomerList: AgencyMaster[];
  agencyCode: string;
  agencyBureauList: AgencyMaster[];
  bureauCode: string;
  agencyBureauData: CustomerOrganization[];
  agencyMasterIdValue: number;
  sroList: RatesSroMaster[];
  organizationId: string;
  sroCode: string;
  agencyMasterId: number;
  agencyLocationId: number;
  agencyMasterIdDetails: AgencyMaster[];
  effectiveDate: string;
  sroMasterDetails: RatesSroMaster;
  sroMasterId: number;

  sroOriginDestinationData: RatesSroOriginDestination[];
  displayModalValue = false;
  originOrDestinationValue: string;
  bureauName: string;
  agencyName: string;
  formatedEffectiveDate: Date;
  formatedExpiryDate: Date;
  origDestDetails: RatesSroOriginDestination[];
  rateTypeDetails: RateTypesSro[] = [];
  disableAddOriginDestinationButton = true;
  showAddress = true;

  assignedRateTypes: RateTypes[];

  allStatesList: StateCountry[] = [];
  allCountriesList: StateCountry[] = [];
  allConusStatesList: StateCountry[] = [];
  // minEffectiveDate: Date;
  minExpiryDate: Date;
  originCount: number;

  neworiginId: number;
  newdestinationId: number;
  deleteflag: boolean;
  disableAgencyField: boolean;
  typeaheadOriginLoading: boolean;
  typeaheadDestinationLoading: boolean;
  frtSroTypes: string[];
  hhgSroTypes: string[];
  rateTypes: any[];
  availRateTypesArray: any[];
  assignedRateType: any;
  sroTypes: string[] = ['General', 'Extended Storage', 'Non-Alternating', 'Alternating', 'Containerized Shipments'];
  sroTypeSelected: any;
  dataSourceOrigin: Observable<any>;
  dataSourceDestination: Observable<any>;
  stateCountry: any;
  showCountryandZone = true;
  origDestLength: number;
  selectedSroCode: string;
  deleteSroButton: boolean = false;
  originAllFlag = false;
  destAllFlag = false;
  sroIDList: string[];

  originSateIdList: any[];
  destinationSateIdList: any[];
  originCountryIdList: any[];
  destinationCountryIdList: any[];
  rateTypeIdList: any[];
  originAddress: any;
  destinationAddress: any;
  resultsPage: any = null;
  modalRef: BsModalRef;
  ratesSroMaintenanceSearchGroup: UntypedFormGroup;
  ratesSroMaintenanceAddGroup: UntypedFormGroup;
  defaultOriginDestinationCountry: any;
  public overlayNoRowsTemplate;


  constructor(
    private fb: UntypedFormBuilder, public loader: LoadingService, private modalService: BsModalService, private alertService: AlertService,
    private agencyMasterService: AgencyMasterService, private ratesSroMasterService: RatesSroMasterService,
    private ratesSroOriginDestinationService: RatesSroOriginDestinationService, private stateCountryService: StateCountryService,
    private hhgService: HhgCarrierRateFilingService
  ) { this.overlayNoRowsTemplate = '<span>No approved TSPs available for the selected query. Please adjust your query options.</span>';
    this.loader = loader;
    this.frameworkComponents = {
      buttonRenderer: ButtonRendererComponent,
    };
    // this.minEffectiveDate = new Date();
    this.minExpiryDate = new Date();
    // this.minEffectiveDate.setDate(this.minEffectiveDate.getDate());
    this.minExpiryDate.setDate(this.minExpiryDate.getDate());
    // Getting Locations data for Typeahead feature
    this.loader.show();
    this.dataSourceOrigin = Observable.create((observer: any) => {
      this.ratesSroMasterService.getLocations(this.ratesSroMaintenanceAddGroup.get('asyncOriginSearchString').value).subscribe((result: any) => {
        observer.next(result);
        this.loader.hide();
      }, () => {
        this.loader.hide();
        this.alertService.error('There was an error retrieving Locations List');
      });
    });
    this.dataSourceDestination = Observable.create((observer: any) => {
      this.ratesSroMasterService.getLocations(this.ratesSroMaintenanceAddGroup.get('asyncDestinationSearchString').value).subscribe((result: any) => {
        observer.next(result);
        this.loader.hide();
      }, () => {
        this.loader.hide();
        this.alertService.error('There was an error retrieving Locations List');
      });
    });
    this.origDestDetails = [];
  }

  ratesSroMaintenanceSearch() {
    this.ratesSroMaintenanceSearchGroup = this.fb.group({
      sroSearch: new UntypedFormControl(null, Validators.minLength(5)),
      agencyName: new UntypedFormControl(null),
      bureauName: new UntypedFormControl(null),
      agencyBureauLocation: new UntypedFormControl(null),
      sroCode: new UntypedFormControl(null),
      effectiveDate: new UntypedFormControl(null, Validators.required),
      expiryDate: new UntypedFormControl(),
      sroType: new UntypedFormControl(null, Validators.required),
      rateType: new UntypedFormControl(null),
      assignedrateType: new UntypedFormControl(null),
      sroNotes: new UntypedFormControl()
    });
  }

  ratesSroMaintenanceAdd() {
    this.ratesSroMaintenanceAddGroup = this.fb.group({
      addOriginState: new UntypedFormControl(null),
      addDestinationState: new UntypedFormControl(null),
      addOriginCountry: new UntypedFormControl(null),
      addDestinationCountry: new UntypedFormControl(null),
      originCity: new UntypedFormControl(null, []),


      originId: new UntypedFormControl(null),
      destinationId: new UntypedFormControl(null),
      asyncOriginSearchString: new UntypedFormControl(null),
      asyncDestinationSearchString: new UntypedFormControl(null),
    });
  }

  ngOnInit() {
    // intializing formgroups
    this.loader.show();
    this.ratesSroMaintenanceAdd();
    this.ratesSroMaintenanceSearch();
    // Get all agencies. Agency list is not volatile, need not go to database every time
    if (!this.agencyCustomerList) {

      this.agencyMasterService.getAllAgency().subscribe(allAgencies => {
        this.agencyCustomerList = allAgencies;
        this.loader.hide();
      }, () => {
        this.loader.hide();
        this.alertService.error('There was an error retrieving agencyName List');
      });
      this.ratesSroMaintenanceSearchGroup.controls['rateType'].disable();
    }

    // Populate SRO types by Business Type
    this.ratesSroMasterService.sroIDsByBusinessType('HHG').subscribe(sTypes => {
      this.sroIDList = sTypes;
      this.loader.hide();
    }, () => {
      this.loader.hide();
      this.alertService.error('There was an error retrieving HHG SRO ID List');
    });
    this.ratesSroMasterService.sroTypesByBusinessType('HHG').subscribe(sTypes => {
      this.sroTypes = sTypes;
      this.loader.hide();
    }, () => {
      this.loader.hide();
      this.alertService.error('There was an error retrieving hhgSroTypes List');
    });

    this.hhgService.getRateTypes().subscribe(rTypes => {
      this.rateTypes = rTypes;
      this.rateTypes.sort((a, b) => a.rateTypeId - b.rateTypeId);
      this.loader.hide();
    }, () => {
      this.loader.hide();
      this.alertService.error('There was an error retrieving HHG Rate Types List');
    });


    // Getting All States and Countries list
    this.stateCountryService.getUSAndCanadaStates().subscribe(allStates => {
      this.allStatesList = this.removeAkHwPrStates(allStates);
      this.loader.hide();
      this.stateCountryService.getAllCountries().subscribe(allCountries => {
        this.allCountriesList = allCountries;
        this.defaultOriginDestinationCountry = allCountries.find(x => {
          return x.stateCountryCode === 'US00';
        });
      }, error => {
        this.loader.hide();
        this.alertService.error('There was an error retrieving all Countries List');
      });
    }, error => {
      this.loader.hide();
      this.alertService.error('There was an error retrieving all US and Canada States List');
    });
    // minimum expiration date changes by effective date
    this.ratesSroMaintenanceSearchGroup.get('effectiveDate').valueChanges.subscribe(data => {
      this.minExpiryDate = this.ratesSroMaintenanceSearchGroup.get('effectiveDate').value;
      if (this.ratesSroMaintenanceSearchGroup.get('expiryDate').value !== null) {
        if (this.ratesSroMaintenanceSearchGroup.get('effectiveDate').value > this.ratesSroMaintenanceSearchGroup.get('expiryDate').value) {
          this.ratesSroMaintenanceSearchGroup.get('expiryDate').setValue(null);
          this.alertService.info('Expiry Date cannot be earlier than Effective Date');
        }
      }
    });
    this.ratesSroMaintenanceSearchGroup.controls['bureauName'].disable();
    // this.ratesSroMaintenanceSearchGroup.controls['agencyBureauLocation'].disable();
    this.ratesSroMaintenanceSearchGroup.controls['sroCode'].disable();
  }

  // Gets called when SRO Type is selected on Define HHG SROs screen
  onSroTypeChange(event: any) {
    this.sroTypeSelected = event;
    this.ratesSroMaintenanceSearchGroup.controls['rateType'].enable();
    this.ratesSroMaintenanceSearchGroup.controls['rateType'].setValue(null);

    // Populate HHG rate types based on selected SRO type
    if (this.sroTypeSelected !== null) {
      this.availRateTypesArray = [];
      this.rateTypes.forEach(e => {
        if (this.sroTypeSelected == 'General') {
          if (e.rateTypeId === 1 || e.rateTypeId === 3 || e.rateTypeId === 5 || e.rateTypeId === 7 || e.rateTypeId === 12 || e.rateTypeId === 14) {
            this.availRateTypesArray.push(e);
          }
        } else if (this.sroTypeSelected == 'Non-Alternating' || this.sroTypeSelected == 'Alternating'){
          if (e.rateTypeId === 2 || e.rateTypeId === 4 || e.rateTypeId === 6 || e.rateTypeId === 8 || e.rateTypeId === 13 || e.rateTypeId === 15) {
            this.availRateTypesArray.push(e);
          }
        } else {
          if (e.rateTypeId === 11){
            this.availRateTypesArray.push(e);
          }
        }

      });

    }

  }

  removeAkHwPrStates(allStates) {
    const refinedStates: StateCountry[] = allStates.filter(x => {
      return x.stateCountryName.toUpperCase() !== 'ALASKA' && x.stateCountryName.toUpperCase() !== 'HAWAIIAN ISLANDS' &&
        x.stateCountryName.toUpperCase() !== 'PUERTO RICO';
    });
    return refinedStates;
  }

  onSroSearch(sroCode: string) {
    if (sroCode) {
      this.loader.show();
      this.selectedSroCode = sroCode;
      // gives SRO object when you pass sroId
      this.ratesSroMasterService.getSroMasterDetails(sroCode, 'HHG').subscribe(sroMasterData => {
        this.sroMasterDetails = sroMasterData;
        this.onSroTypeChange(sroMasterData.sroType);
        this.loader.hide();
        if (this.sroMasterDetails.deletedFlag === 1) {
          this.alertService.info('This SRO Id is exist but has Delete Flag');
          this.ratesSroMaintenanceAddGroup.reset();
          this.ratesSroMaintenanceSearchGroup.reset();
          this.ratesSroMaintenanceSearchGroup.controls['sroSearch'].setValue(sroCode);
        } else {
          this.deleteSroButton = true;
          this.onSroChange(sroCode);
          this.agencyMasterIdValue = this.sroMasterDetails.agencyMasterId;
          // returns details for a specific AgencyMasterId
          this.loadSRODetailsByAgencyMasterId(this.agencyMasterIdValue);
        }
      }, () => {
        this.loader.hide();
        delay(4000);
        this.modalRef = this.modalService.show(ConfirmationModalComponent);
        this.modalRef.content.question = 'Do You Want to Create a New SRO Code';
        this.modalRef.content.title = 'Error Retrieving SRO Details by SRO Code';
        this.modalRef.content.confirmText = 'Yes';
        this.modalRef.content.cancelText = 'No';
        this.modalRef.content.emitData.subscribe(result => {
          if (result.obj === true) {
            this.clearForm();
            this.ratesSroMaintenanceAddGroup.reset();
            this.ratesSroMaintenanceSearchGroup.reset();
            this.ratesSroMaintenanceSearchGroup.controls['sroSearch'].setValue(sroCode);
            this.loader.show();
            this.agencyMasterService.getAllAgency().subscribe(allAgencies => {
              this.agencyCustomerList = allAgencies;
              this.loader.hide();
              this.ratesSroMaintenanceSearchGroup.controls['agencyName'].enable();
              this.deleteflag = false;
              this.ratesSroMaintenanceSearchGroup.controls['sroCode'].disable();
              this.ratesSroMaintenanceSearchGroup.controls['sroType'].enable();
            }, () => {
              this.loader.hide();
              this.alertService.error('There was an error retrieving agencyName List');
            });
          }
        });
       // this.loader.hide();
      });
    } else {
      this.alertService.info('SRO ID cannot be empty');
    }
  }

  onAgencyNameChange(event: any) {
    this.ratesSroMaintenanceSearchGroup.get('agencyName').setValue(event.item.agencyBureauName + ' - ' + event.item.agencyCode);
    this.disableAddOriginDestinationButton = false;
    this.ratesSroMaintenanceAddGroup.reset();
    this.ratesSroMaintenanceSearchGroup.controls['bureauName'].setValue(null);
    this.ratesSroMaintenanceSearchGroup.controls['agencyBureauLocation'].setValue(null);
    this.ratesSroMaintenanceSearchGroup.controls['sroCode'].setValue(null);
    const agencyCodeValue = event.item.agencyCode;
    if (agencyCodeValue) {
      // User selected Agency from the Agency List
      // Get all Bureau for selected Agency
      this.agencyCode = agencyCodeValue;
      this.loader.show();
      this.agencyMasterService.getAllBureauByAgency(this.agencyCode).subscribe(allBureau => {
        this.agencyBureauList = allBureau;
        this.loader.hide();
        this.ratesSroMaintenanceSearchGroup.controls['bureauName'].enable();
        this.ratesSroMaintenanceSearchGroup.controls['agencyBureauLocation'].enable();
      }, error => {
        this.loader.hide();
        this.alertService.error('There was an error retrieving Agency Bureau List');
        this.ratesSroMaintenanceSearchGroup.controls['agencyName'].setValue(null);
      });
    } else {
      this.alertService.error('There was an error getting Agency Code or Null');
    }
  }

  loadSRODetailsByAgencyMasterId(agMasterID: number) {
    if (agMasterID === null) {
      this.ratesSroMaintenanceSearchGroup.controls['agencyName'].setValue(null);
      this.ratesSroMaintenanceSearchGroup.controls['bureauName'].setValue(null);
      this.ratesSroMaintenanceSearchGroup.controls['agencyName'].disable();
      this.ratesSroMaintenanceSearchGroup.controls['bureauName'].disable();
      // this.ratesSroMaintenanceSearchGroup.controls['sroType'].disable();
      this.disableAddOriginDestinationButton = false;
      this.sroList = [];
      this.sroMasterDetails.sroId = this.selectedSroCode;
      this.sroList.push(this.sroMasterDetails);
      this.ratesSroMaintenanceSearchGroup.controls['sroCode'].setValue(this.selectedSroCode);
    } else {
      this.loader.show();
      this.agencyMasterService.getDetailsByAgencyMasterId(agMasterID).subscribe(agencyMasterDetails => {
        this.agencyMasterIdDetails = [];
        this.agencyMasterIdDetails[0] = agencyMasterDetails;
        this.agencyCode = this.agencyMasterIdDetails[0].agencyCode;
        this.bureauCode = this.agencyMasterIdDetails[0].bureauCode;
        this.agencyMasterService.getAgencyBureauNameByAgencyCode(this.agencyCode).subscribe(() => {
          this.agencyCustomerList = this.agencyMasterIdDetails;
          this.ratesSroMaintenanceSearchGroup.controls['agencyName'].setValue(this.agencyCode);
          this.agencyBureauList = this.agencyMasterIdDetails;
          this.ratesSroMaintenanceSearchGroup.controls['bureauName'].setValue(this.bureauCode);
          this.agencyMasterService.getAgencyUsersByAgencyCodeAndBureauCode(this.agencyCode, this.bureauCode).subscribe(agencyBureauDetails => {
            this.agencyBureauData = agencyBureauDetails;
            this.ratesSroMaintenanceSearchGroup.controls['agencyBureauLocation'].setValue(this.agencyLocationId);
            this.ratesSroMaintenanceSearchGroup.controls['agencyName'].disable();
            this.ratesSroMaintenanceSearchGroup.controls['sroCode'].disable();
            this.ratesSroMaintenanceSearchGroup.controls['bureauName'].disable();
            // this.ratesSroMaintenanceSearchGroup.controls['sroType'].disable();
            this.agencyMasterService.getAllAgency().subscribe(allAgencies => {
              this.agencyCustomerList = allAgencies;
              this.ratesSroMasterService.getSroListByAgencyMasterId(this.agencyMasterIdValue).subscribe(sroListOfAgencyId => {
                this.sroList = sroListOfAgencyId;
                if (!this.sroList.length) {
                  this.sroList = [];
                  this.sroMasterDetails.sroId = this.selectedSroCode;
                  this.sroList.push(this.sroMasterDetails);
                }
                this.ratesSroMaintenanceSearchGroup.controls['sroCode'].setValue(this.sroMasterDetails.sroId);
                this.ratesSroMaintenanceSearchGroup.controls['agencyBureauLocation'].setValue(this.agencyLocationId);
                this.loader.hide();
                this.deleteflag = true;
              }, error => {
                this.loader.hide();
                this.alertService.error('There was an error retrieving SRO List by AgencyMasterId');
              });
            }, error => {
              this.loader.hide();
              this.alertService.error('There was an error retrieving agencyName List');
            });
          }, error => {
            this.loader.hide();
            this.alertService.error('There was an error retrieving Agency Bureau List');
          });
        }, error => {
          this.loader.hide();
          this.alertService.error('There was an error retrieving Agency Bureau List');
        });
      }, error => {
        this.loader.hide();
        this.alertService.error('There was an error retrieving Agency Bureau List');
      });
    }

  }

  onBureauChange(bureauCodeValue: string) {
    this.ratesSroMaintenanceSearchGroup.controls['agencyBureauLocation'].setValue(null);
    this.ratesSroMaintenanceSearchGroup.controls['sroCode'].setValue(null);
    if (bureauCodeValue) {
      // User selected Agency & Bureau from the Agency List
      // Get all Agency Bureau users for selected
      this.bureauCode = bureauCodeValue;
      this.loader.show();
      // get all agency users based on agency code and bureau code
      this.agencyMasterService.getAgencyUsersByAgencyCodeAndBureauCode(this.agencyCode, this.bureauCode).subscribe(agencyBureauDetails => {
        this.agencyBureauData = agencyBureauDetails;
        // getting agencyMasterId from the list
        this.agencyMasterIdValue = this.agencyBureauData[0].agencyMasterId;
        if (this.agencyMasterIdValue === null) {
          this.ratesSroMaintenanceSearchGroup.controls['sroCode'].setValue(this.selectedSroCode);
        } else {
          this.ratesSroMasterService.getSroListByAgencyMasterId(this.agencyMasterIdValue).subscribe(sroListOfAgencyId => {
            this.sroList = sroListOfAgencyId;
            if (this.sroList === null) {
              this.sroList = [];
              this.sroMasterDetails.sroId = this.selectedSroCode;
              this.sroList.push(this.sroMasterDetails);
              this.ratesSroMaintenanceSearchGroup.controls['sroCode'].setValue(this.selectedSroCode);
            }

            this.loader.hide();
          }, error => {
            this.loader.hide();
            this.alertService.error('There was an error retrieving SRO List by AgencyMasterId');
          });
        }

        if (this.ratesSroMaintenanceSearchGroup.get('sroSearch').value === null) {
          this.ratesSroMaintenanceSearchGroup.controls['sroCode'].enable();
          this.ratesSroMaintenanceSearchGroup.get('sroCode').setValidators([Validators.required]);
          this.ratesSroMaintenanceSearchGroup.get('sroCode').updateValueAndValidity();
        } else {
          this.ratesSroMaintenanceSearchGroup.controls['sroCode'].disable();
          this.ratesSroMaintenanceSearchGroup.get('sroCode').setValidators([]);
          this.ratesSroMaintenanceSearchGroup.get('sroCode').updateValueAndValidity();
        }
        this.loader.hide();
      }, error => {
        this.loader.hide();
        this.alertService.error('There was an error retrieving Agency Bureau List');
        this.ratesSroMaintenanceSearchGroup.controls['bureauName'].setValue(null);
      });
    } else {
      this.alertService.error('There was an error getting Bureau Code or Null');
    }
  }

  onSroChange(sroCode: string) {
    this.origDestDetails = [];
    if (sroCode) {
      // User selected SRO code and not Null
      // Get all SRO details
      this.sroCode = sroCode;
      this.loader.show();
      // gives SRO object when you pass sroId
      this.ratesSroMasterService.getSroMasterDetails(sroCode, 'HHG').subscribe(sroMasterData => {
        this.sroMasterDetails = sroMasterData;
        if (this.sroMasterDetails.deletedFlag === 1) {
          this.alertService.info('This SRO Id is exist but has Delete Flag');
          this.ratesSroMaintenanceSearchGroup.controls['sroCode'].setValue(null);
        } else {
          this.sroMasterId = this.sroMasterDetails.sroMasterId;
          this.agencyLocationId = this.sroMasterDetails.agencyId;

          this.rateTypeDetails = Array.from(new Set(this.sroMasterDetails.rateTypesSroEntity));
          if (this.rateTypeDetails != null && this.rateTypeDetails.length > 0) {
            this.assignedRateTypes = [];
            this.rateTypeDetails.forEach(a => {
              this.rateTypes.forEach(b => {
                if (a.rateTypeId === b.rateTypeId) {
                  const tempRateType: RateTypes = new RateTypes();
                  tempRateType.rateTypeId = b.rateTypeId;
                  tempRateType.legacyRateType = b.legacyRateType;
                  tempRateType.description = b.description;
                  this.assignedRateTypes.push(tempRateType);
                }
              });
            });
          }
          this.ratesSroMaintenanceSearchGroup.controls['sroSearch'].setValue(this.sroMasterDetails.sroId);
          this.ratesSroMaintenanceSearchGroup.controls['sroCode'].setValue(this.sroMasterDetails.sroId);
          if (this.sroMasterDetails.effectiveDate === null) {
            this.ratesSroMaintenanceSearchGroup.controls['effectiveDate'].setValue(null);
          } else {
            this.ratesSroMaintenanceSearchGroup.controls['effectiveDate'].setValue(new Date(this.sroMasterDetails.effectiveDate));
          }
          if (this.sroMasterDetails.expiryDate === null) {
            this.ratesSroMaintenanceSearchGroup.controls['expiryDate'].setValue(null);
          } else {
            this.ratesSroMaintenanceSearchGroup.controls['expiryDate'].setValue(new Date(this.sroMasterDetails.expiryDate));
          }
          this.ratesSroMaintenanceSearchGroup.controls['sroType'].setValue(this.sroMasterDetails.sroType);
          this.ratesSroMaintenanceSearchGroup.controls['sroNotes'].setValue(this.sroMasterDetails.sroNotes);
          this.ratesSroMaintenanceSearchGroup.controls['rateType'].setValue(this.sroMasterDetails.agencyId);
          this.ratesSroOriginDestinationService.getOriginDestination(this.sroMasterId).subscribe(sroOriginDestinationDetails => {
            this.sroOriginDestinationData = sroOriginDestinationDetails;
            this.origDestDetails = [];
            for (const sroOriginDestination of this.sroOriginDestinationData) {
              const newOriginDestData: RatesSroOriginDestination = new RatesSroOriginDestination();
              for (const z of this.allCountriesList) {
                if (z.stateCountryType === 'Country' && z.stateCountryId === sroOriginDestination.originId) {
                  newOriginDestData.stateCountryOrigDetails = z;
                  break;
                }
              }
              for (const z of this.allCountriesList) {
                if (z.stateCountryType === 'Country' && z.stateCountryId === sroOriginDestination.originId) {
                  const newOriginDestData: RatesSroOriginDestination = new RatesSroOriginDestination();
                  newOriginDestData.stateCountryOrigDetails = z;
                  break;
                }
              }
              for (const z of this.allStatesList) {
                if (z.stateCountryType === 'State' && z.stateCountryId === sroOriginDestination.originId) {
                  newOriginDestData.originState = z.stateCountryName;
                  break;
                }
              }
              newOriginDestData.originId = sroOriginDestination.originId;
              newOriginDestData.originCity = sroOriginDestination.originCity;
              newOriginDestData.originZip = sroOriginDestination.originZip;
              for (const z of this.allCountriesList) {
                if (z.stateCountryType === 'Country' && z.stateCountryId === sroOriginDestination.destinationId) {
                  newOriginDestData.stateCountryDestDetails = z;
                  break;
                }
              }
              for (const z of this.allStatesList) {
                if (z.stateCountryType === 'State' && z.stateCountryId === sroOriginDestination.destinationId) {
                  newOriginDestData.destinationState = z.stateCountryName;
                  break;
                }
              }
              newOriginDestData.destinationId = sroOriginDestination.destinationId;
              newOriginDestData.destinationCity = sroOriginDestination.destinationCity;
              newOriginDestData.destinationZip = sroOriginDestination.destinationZip;

              this.origDestDetails.push(newOriginDestData);

            }
            // creating a list from the  and destinationMap and destinationAllMap
            // this.setupOriginPagination();
            this.gridApi.setGridOption('rowData', this.origDestDetails);

            this.loader.hide();
          }, error => {
            this.loader.hide();
            this.alertService.error('There was an error retrieving SRO Details by SRO Code');
          });

        }

      }, error => {
        this.loader.hide();
        this.alertService.error('There was an error retrieving SRO Details by SRO Code');
        this.ratesSroMaintenanceSearchGroup.controls['sroCode'].setValue(null);
      });
    } else {
      this.alertService.error('Error getting SRO ID');
    }
  }



  sroListByAgencyIdAndLocation(organizationId: any) {
    this.ratesSroMaintenanceSearchGroup.controls['sroCode'].setValue(null);
    this.organizationId = organizationId;
    if (AppConstants.isNotNullCondition(organizationId)) {
      if (this.agencyMasterIdValue) {
        this.loader.show();
        this.ratesSroMasterService.getSroListByAgencyMasterIdAndLocationCode(this.agencyMasterIdValue, this.organizationId).subscribe(sroListOfAgencyMasterIdAndAgencyId => {
          this.sroList = sroListOfAgencyMasterIdAndAgencyId;
          this.loader.hide();
        }, error => {
          this.loader.hide();
          this.alertService.error('There was an error retrieving SRO List by AgencyMasterId and Location');
          this.ratesSroMaintenanceSearchGroup.controls['agencyBureauLocation'].setValue(null);
        });
      }
    }
  }
  addOrigDestLanes() {
    this.ratesSroMaintenanceAddGroup.reset();

  }
  addOriginDestination() {
    // this.origDestDetails = [];
    this.stateCountryService.getAllConcorStates().subscribe(allCStates => {
      this.allConusStatesList = allCStates;
      this.loader.hide();
    }, error => {
      this.loader.hide();
      this.alertService.error('There was an error retrieving all Conus States List');
    });
    this.originSateIdList = this.ratesSroMaintenanceAddGroup.get('addOriginState').value;
    this.destinationSateIdList = this.ratesSroMaintenanceAddGroup.get('addDestinationState').value;
    this.originCountryIdList = this.ratesSroMaintenanceAddGroup.get('addOriginCountry').value;
    this.destinationCountryIdList = this.ratesSroMaintenanceAddGroup.get('addDestinationCountry').value;
    this.originAddress = this.ratesSroMaintenanceAddGroup.get('originId').value;
    this.destinationAddress = this.ratesSroMaintenanceAddGroup.get('destinationId').value;


    if (this.originSateIdList !== null && this.originSateIdList.length > 0 &&
      this.destinationSateIdList !== null && this.destinationSateIdList.length > 0) {
      this.originSateIdList.forEach(o => {
        this.destinationSateIdList.forEach(d => {
          if (o === 'AllStates' && d === 'AllStates') {
            this.processAllConcusStates();
          } else if (o === 'AllStates' && d !== 'AllStates') {
            if (d != null && d !== '') {
              for (const destStateCountry of this.allStatesList) {
                if (destStateCountry.stateCountryId === d) {
                  const newOriginDestData: RatesSroOriginDestination = new RatesSroOriginDestination();
                  newOriginDestData.originId = null;
                  newOriginDestData.originCity = 'All CONUS States';
                  newOriginDestData.destinationId = destStateCountry.stateCountryId;
                  newOriginDestData.destinationState = destStateCountry.stateCountryName;
                  this.origDestDetails.push(newOriginDestData);
                }

              }
            }
          } else if (o !== 'AllStates' && d === 'AllStates') {
            if (d != null && d !== '') {
              for (const originStateCountry of this.allStatesList) {
                if (originStateCountry.stateCountryId === o) {
                  const newOriginDestData: RatesSroOriginDestination = new RatesSroOriginDestination();
                  newOriginDestData.originId = originStateCountry.stateCountryId;
                  newOriginDestData.originCity = originStateCountry.stateCountryName;
                  newOriginDestData.destinationId = null;
                  newOriginDestData.destinationCity = 'All CONUS States';
                  this.origDestDetails.push(newOriginDestData);
                }
              }
            }
          } else {
            if (o != null && o !== '' && d != null && d !== '') {
              for (const originStateCountry of this.allStatesList) {
                if (originStateCountry.stateCountryId === o) {
                  for (const destStateCountry of this.allStatesList) {
                    if (destStateCountry.stateCountryId === d) {
                      this.processOriginDestData(originStateCountry, destStateCountry);
                    }
                  }
                }
              }
            }
          }

        });

      });
    }
    if (this.originSateIdList !== null && this.originSateIdList.length > 0 &&
      this.destinationCountryIdList !== null && this.destinationCountryIdList.length > 0) {
      this.originSateIdList.forEach(o => {
        this.destinationCountryIdList.forEach(d => {
          if (o === 'AllStates' && d === 'AllCountries') {
            const newOriginDestData: RatesSroOriginDestination = new RatesSroOriginDestination();
            newOriginDestData.originId = null;
            newOriginDestData.destinationId = null;
            newOriginDestData.originCity = 'All CONUS States';
            newOriginDestData.destinationCity = 'All Countries';
            this.origDestDetails.push(newOriginDestData);
          }
          if (o === 'AllStates' && d != null && d !== '') {
            for (const destStateCountry of this.allCountriesList) {
              if (destStateCountry.stateCountryId === d) {
                const newOriginDestData: RatesSroOriginDestination = new RatesSroOriginDestination();
                newOriginDestData.originId = null;
                newOriginDestData.originCity = 'All CONUS States';
                newOriginDestData.destinationId = destStateCountry.stateCountryId;
                newOriginDestData.stateCountryDestDetails = destStateCountry;
                this.origDestDetails.push(newOriginDestData);
              }
            }

          } else if (o !== 'AllStates' && d === 'AllCountries') {// AllStates
            for (const stateCountry of this.allStatesList) {
              if (stateCountry.stateCountryId === o) {
                const newOriginDestData: RatesSroOriginDestination = new RatesSroOriginDestination();
                newOriginDestData.originId = stateCountry.stateCountryId;
                newOriginDestData.stateCountryOrigDetails = stateCountry;
                newOriginDestData.destinationId = null;
                newOriginDestData.destinationCity = 'All Countries';
                this.origDestDetails.push(newOriginDestData);
              }
            }
          } else {
            for (const originStateCountry of this.allStatesList) {
              if (originStateCountry.stateCountryId === o) {
                for (const destStateCountry of this.allCountriesList) {
                  if (destStateCountry.stateCountryId === d) {
                    const newOriginDestData: RatesSroOriginDestination = new RatesSroOriginDestination();
                    newOriginDestData.originId = originStateCountry.stateCountryId;
                    newOriginDestData.originState = originStateCountry.stateCountryName;
                    newOriginDestData.destinationId = destStateCountry.stateCountryId;
                    newOriginDestData.stateCountryDestDetails = destStateCountry;
                    this.origDestDetails.push(newOriginDestData);
                  }
                }
              }
            }
          }
        });
      });
    }
    if (this.originSateIdList !== null && this.originSateIdList.length > 0 &&
      this.destinationAddress !== null && this.destinationAddress) {
      this.originSateIdList.forEach(o => {
        if (o === 'AllStates') {
          for (const originStateCountry of this.allConusStatesList) {
            if (originStateCountry.stateCountryCode2Digit === this.destinationAddress.stateAbbrev &&
              originStateCountry.stateCountryType === 'State') {
              const newOriginDestData: RatesSroOriginDestination = new RatesSroOriginDestination();
              newOriginDestData.originId = null;
              newOriginDestData.originCity = 'All CONUS States';
              newOriginDestData.destinationCity = this.destinationAddress.cityName;
              newOriginDestData.destinationZip = this.destinationAddress.zipCode;
              newOriginDestData.destinationId = originStateCountry.stateCountryId;
              newOriginDestData.destinationState = originStateCountry.stateCountryName;
              this.origDestDetails.push(newOriginDestData);
            }

          }
        } else {
          for (const originStateCountry of this.allStatesList) {
            if (originStateCountry.stateCountryId === o) {
              const newOriginDestData: RatesSroOriginDestination = new RatesSroOriginDestination();
              newOriginDestData.originId = originStateCountry.stateCountryId;
              newOriginDestData.originState = originStateCountry.stateCountryName;
              for (const tempState of this.allStatesList) {
                if (tempState.stateCountryCode2Digit === this.destinationAddress.stateAbbrev &&
                  tempState.stateCountryType === 'State') {
                  newOriginDestData.destinationCity = this.destinationAddress.cityName;
                  newOriginDestData.destinationZip = this.destinationAddress.zipCode;
                  newOriginDestData.destinationId = tempState.stateCountryId;
                  newOriginDestData.destinationState = tempState.stateCountryName;
                  this.origDestDetails.push(newOriginDestData);
                }
              }
            }
          }
        }
      });
    }
    if (this.originCountryIdList !== null && this.originCountryIdList.length > 0 &&
      this.destinationSateIdList !== null && this.destinationSateIdList.length > 0) {
      this.originCountryIdList.forEach(o => {
        this.destinationSateIdList.forEach(d => {
          if (o === 'AllCountries' && d === 'AllStates') {
            const newOriginDestData: RatesSroOriginDestination = new RatesSroOriginDestination();
            newOriginDestData.originId = null;
            newOriginDestData.destinationId = null;
            newOriginDestData.originCity = 'All Countries';
            newOriginDestData.destinationCity = 'All CONUS States';
            this.origDestDetails.push(newOriginDestData);
          } else if (o === 'AllCountries' && d !== 'AllStates') {
            for (const stateCountry of this.allStatesList) {
              if (stateCountry.stateCountryId === d) {
                const newOriginDestData: RatesSroOriginDestination = new RatesSroOriginDestination();
                newOriginDestData.originId = null;
                newOriginDestData.originCity = 'All Countries';
                newOriginDestData.stateCountryDestDetails = stateCountry;
                newOriginDestData.destinationId = stateCountry.stateCountryId;
                this.origDestDetails.push(newOriginDestData);
              }
            }
          } else if (o !== 'AllCountries' && d === 'AllStates') {
            for (const stateCountry of this.allCountriesList) {
              if (stateCountry.stateCountryId === o) {
                const newOriginDestData: RatesSroOriginDestination = new RatesSroOriginDestination();
                newOriginDestData.originId = stateCountry.stateCountryId;
                newOriginDestData.stateCountryOrigDetails = stateCountry;
                newOriginDestData.destinationId = null;
                newOriginDestData.destinationCity = 'All CONUS States';
                this.origDestDetails.push(newOriginDestData);
              }
            }
          } else {
            for (const originStateCountry of this.allCountriesList) {
              if (originStateCountry.stateCountryId === o) {
                for (const destStateCountry of this.allStatesList) {
                  if (destStateCountry.stateCountryId === d) {
                    const newOriginDestData: RatesSroOriginDestination = new RatesSroOriginDestination();
                    newOriginDestData.originId = originStateCountry.stateCountryId;
                    newOriginDestData.stateCountryOrigDetails = originStateCountry;
                    newOriginDestData.destinationId = destStateCountry.stateCountryId;
                    newOriginDestData.destinationState = destStateCountry.stateCountryName;
                    this.origDestDetails.push(newOriginDestData);
                  }
                }
              }
            }
          }
        });
      });
    }
    if (this.originCountryIdList !== null && this.originCountryIdList.length > 0 &&
      this.destinationCountryIdList !== null && this.destinationCountryIdList.length > 0) {
      this.originCountryIdList.forEach(o => {
        this.destinationCountryIdList.forEach(d => {
          if (o === 'AllCountries' && d === 'AllCountries') {
            const newOriginDestData: RatesSroOriginDestination = new RatesSroOriginDestination();
            newOriginDestData.originId = null;
            newOriginDestData.destinationId = null;
            newOriginDestData.originCity = 'All Countries';
            newOriginDestData.destinationCity = 'All Countries';
            this.origDestDetails.push(newOriginDestData);
          } else if (o === 'AllCountries' && d !== 'AllCountries') {
            if (d != null && d !== '') {
              for (const destStateCountry of this.allCountriesList) {
                if (destStateCountry.stateCountryId === d) {
                  const newOriginDestData: RatesSroOriginDestination = new RatesSroOriginDestination();
                  newOriginDestData.originId = null;
                  newOriginDestData.originCity = 'All Countries';
                  newOriginDestData.destinationId = destStateCountry.stateCountryId;
                  newOriginDestData.stateCountryDestDetails = destStateCountry;
                  this.origDestDetails.push(newOriginDestData);
                }
              }
            }
          } else if (o !== 'AllCountries' && d === 'AllCountries') {
            if (d != null && d !== '') {
              for (const originStateCountry of this.allCountriesList) {
                if (originStateCountry.stateCountryId === o) {
                  const newOriginDestData: RatesSroOriginDestination = new RatesSroOriginDestination();
                  newOriginDestData.originId = originStateCountry.stateCountryId;
                  newOriginDestData.stateCountryOrigDetails = originStateCountry;
                  newOriginDestData.destinationId = null;
                  newOriginDestData.destinationCity = 'All Countries';
                  this.origDestDetails.push(newOriginDestData);
                }
              }
            }
          } else {
            for (const originStateCountry of this.allCountriesList) {
              if (originStateCountry.stateCountryId === o) {
                for (const destStateCountry of this.allCountriesList) {
                  if (destStateCountry.stateCountryId === d) {
                    const newOriginDestData: RatesSroOriginDestination = new RatesSroOriginDestination();
                    newOriginDestData.originId = originStateCountry.stateCountryId;
                    newOriginDestData.stateCountryOrigDetails = originStateCountry;
                    newOriginDestData.destinationId = destStateCountry.stateCountryId;
                    newOriginDestData.stateCountryDestDetails = destStateCountry;
                    this.origDestDetails.push(newOriginDestData);
                  }
                }
              }
            }
          }
        });
      });
    }
    if (this.originCountryIdList !== null && this.originCountryIdList.length > 0 &&
      this.destinationAddress !== null && this.destinationAddress !== '') {
      this.originCountryIdList.forEach(o => {
        if (o === 'AllCountries') {
          const newOriginDestData: RatesSroOriginDestination = new RatesSroOriginDestination();
          newOriginDestData.destinationId = null;
          newOriginDestData.originCity = 'All Countries';
          for (const tempState of this.allStatesList) {
            if (tempState.stateCountryCode2Digit === this.destinationAddress.stateAbbrev &&
              tempState.stateCountryType === 'State') {
              newOriginDestData.destinationCity = this.destinationAddress.cityName;
              newOriginDestData.destinationZip = this.destinationAddress.zipCode;
              newOriginDestData.destinationId = tempState.stateCountryId;
              newOriginDestData.destinationState = tempState.stateCountryName;
              this.origDestDetails.push(newOriginDestData);
            }
          }
        } else {
          for (const originStateCountry of this.allCountriesList) {
            if (originStateCountry.stateCountryId === o) {
              const newOriginDestData: RatesSroOriginDestination = new RatesSroOriginDestination();
              newOriginDestData.originId = originStateCountry.stateCountryId;
              newOriginDestData.stateCountryOrigDetails = originStateCountry;
              for (const tempState of this.allStatesList) {
                if (tempState.stateCountryCode2Digit === this.destinationAddress.stateAbbrev &&
                  tempState.stateCountryType === 'State') {
                  newOriginDestData.destinationCity = this.destinationAddress.cityName;
                  newOriginDestData.destinationZip = this.destinationAddress.zipCode;
                  newOriginDestData.destinationId = tempState.stateCountryId;
                  newOriginDestData.destinationState = tempState.stateCountryName;
                  this.origDestDetails.push(newOriginDestData);
                }
              }
            }
          }
        }
      });
    }
    if (this.originAddress !== null && this.originAddress !== '' &&
      this.destinationSateIdList !== null && this.destinationSateIdList.length > 0) {
      this.destinationSateIdList.forEach(d => {
        if (d === 'AllStates') {
          for (const destStateCountry of this.allStatesList) {
            const newOriginDestData: RatesSroOriginDestination = new RatesSroOriginDestination();
            if (destStateCountry.stateCountryCode2Digit === this.originAddress.stateAbbrev &&
              destStateCountry.stateCountryType === 'State') {
              newOriginDestData.originCity = this.originAddress.cityName;
              newOriginDestData.originZip = this.originAddress.zipCode;
              newOriginDestData.originId = destStateCountry.stateCountryId;
              newOriginDestData.originState = destStateCountry.stateCountryName;
              newOriginDestData.destinationId = null;
              newOriginDestData.destinationCity = 'All CONUS States';
              this.origDestDetails.push(newOriginDestData);
            }
          }
        } else {
          for (const destStateCountry of this.allStatesList) {
            const newOriginDestData: RatesSroOriginDestination = new RatesSroOriginDestination();
            if (destStateCountry.stateCountryCode2Digit === this.originAddress.stateAbbrev &&
              destStateCountry.stateCountryType === 'State') {
              newOriginDestData.originCity = this.originAddress.cityName;
              newOriginDestData.originZip = this.originAddress.zipCode;
              newOriginDestData.originId = destStateCountry.stateCountryId;
              newOriginDestData.originState = destStateCountry.stateCountryName;
              for (const tempState of this.allStatesList) {
                if (tempState.stateCountryId === d) {
                  newOriginDestData.destinationId = tempState.stateCountryId;
                  newOriginDestData.destinationState = tempState.stateCountryName;
                  this.origDestDetails.push(newOriginDestData);
                }
              }
            }
          }
        }
      });
    }
    if (this.originAddress !== null && this.originAddress !== '' &&
      this.destinationCountryIdList !== null && this.destinationCountryIdList.length > 0) {
      this.destinationCountryIdList.forEach(d => {

        if (d === 'AllCountries') {
          for (const destStateCountry of this.allStatesList) {
            const newOriginDestData: RatesSroOriginDestination = new RatesSroOriginDestination();
            if (destStateCountry.stateCountryCode2Digit === this.originAddress.stateAbbrev &&
              destStateCountry.stateCountryType === 'State') {
              newOriginDestData.originCity = this.originAddress.cityName;
              newOriginDestData.originZip = this.originAddress.zipCode;
              newOriginDestData.originId = destStateCountry.stateCountryId;
              newOriginDestData.originState = destStateCountry.stateCountryName;
              newOriginDestData.destinationId = null;
              newOriginDestData.destinationCity = 'All Countries';
              this.origDestDetails.push(newOriginDestData);
            }
          }
        } else {
          for (const destStateCountry of this.allStatesList) {
            const newOriginDestData: RatesSroOriginDestination = new RatesSroOriginDestination();
            if (destStateCountry.stateCountryCode2Digit === this.originAddress.stateAbbrev &&
              destStateCountry.stateCountryType === 'State') {
              newOriginDestData.originCity = this.originAddress.cityName;
              newOriginDestData.originZip = this.originAddress.zipCode;
              newOriginDestData.originId = destStateCountry.stateCountryId;
              newOriginDestData.originState = destStateCountry.stateCountryName;
              for (const tempState of this.allCountriesList) {
                if (tempState.stateCountryId === d) {
                  newOriginDestData.destinationId = tempState.stateCountryId;
                  newOriginDestData.destinationState = tempState.stateCountryName;
                  this.origDestDetails.push(newOriginDestData);
                }
              }
            }
          }
        }
      });
    }
    if (this.originAddress !== null && this.originAddress !== '' &&
      this.destinationAddress !== null && this.destinationAddress !== '') {

      const newOriginDestData: RatesSroOriginDestination = new RatesSroOriginDestination();
      for (const addressStateCountry of this.allStatesList) {
        if (addressStateCountry.stateCountryCode2Digit === this.originAddress.stateAbbrev &&
          addressStateCountry.stateCountryType === 'State') {
          newOriginDestData.originCity = this.originAddress.cityName;
          newOriginDestData.originZip = this.originAddress.zipCode;
          newOriginDestData.originId = addressStateCountry.stateCountryId;
          newOriginDestData.originState = addressStateCountry.stateCountryName;
        }
        if (addressStateCountry.stateCountryCode2Digit === this.destinationAddress.stateAbbrev &&
          addressStateCountry.stateCountryType === 'State') {
          newOriginDestData.destinationCity = this.destinationAddress.cityName;
          newOriginDestData.destinationZip = this.destinationAddress.zipCode;
          newOriginDestData.destinationId = addressStateCountry.stateCountryId;
          newOriginDestData.destinationState = addressStateCountry.stateCountryName;
        }
      }
      this.origDestDetails.push(newOriginDestData);

    }

    this.origDestLength = this.origDestDetails.length;
    this.gridApi.setGridOption('rowData', this.origDestDetails);
  }
  processAllConcusStates() {
    const newOriginDestData: RatesSroOriginDestination = new RatesSroOriginDestination();
    newOriginDestData.originId = null;
    newOriginDestData.destinationId = null;
    newOriginDestData.originCity = 'All CONUS States';
    newOriginDestData.destinationCity = 'All CONUS States';
    this.origDestDetails.push(newOriginDestData);
  }
  processOriginDestData(originStateCountry: StateCountry, destStateCountry: StateCountry) {
    const newOriginDestData: RatesSroOriginDestination = new RatesSroOriginDestination();
    newOriginDestData.originId = originStateCountry.stateCountryId;
    newOriginDestData.destinationId = destStateCountry.stateCountryId;
    newOriginDestData.originState = originStateCountry.stateCountryName;
    newOriginDestData.destinationState = destStateCountry.stateCountryName;
    this.origDestDetails.push(newOriginDestData);
  }
  processOriginDestZonesData(originStateCountry: StateCountry, destStateCountry: StateCountry) {
    const newOriginDestData: RatesSroOriginDestination = new RatesSroOriginDestination();
    newOriginDestData.stateCountryOrigDetails = originStateCountry;
    newOriginDestData.stateCountryDestDetails = destStateCountry;
    this.origDestDetails.push(newOriginDestData);
  }

  private initializeGridOptions() {
    return <GridOptions>{
      columnDefs: this.getOrigDestColumnDefs(),
      context: { parentComponent: this },
      rowSelection: 'single',
      rowHeight: 45,
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      headerHeight: 25,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      domLayout: 'autoHeight',
      rowData: this.origDestDetails,
      onGridReady: params => {
        params.api.sizeColumnsToFit();
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
      // overlayNoRowsTemplate:
      //  '<span>No rows to display, please add lanes</span>'
    };
  }
  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.setGridOption('groupHeaderHeight', 48);
    this.gridApi.setGridOption('headerHeight', 48);
    this.gridApi.setGridOption('rowData', this.origDestDetails);
    this.gridApi = params.api;
    // params.api.setRowData(this.origDestDetails);
  }
  getOrigDestColumnDefs(): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
      {
        headerName: 'Origin Country/Zone',
        field: 'stateCountryOrigDetails.stateCountryName',
        filter: 'agTextColumnFilter'

      },
      {
        headerName: 'Origin City',
        field: 'originCity',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Origin State',
        field: 'originState',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Origin Zip',
        field: 'originZip',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Destination Country/Zone',
        field: 'stateCountryDestDetails.stateCountryName',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Destination City',
        field: 'destinationCity',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Destination State',
        field: 'destinationState',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Destination Zip',
        field: 'destinationZip',
        filter: 'agTextColumnFilter'

      },
      {
        headerName: 'Delete',
        cellRendererSelector: function (params) {
          const buttonRenderer = {
            component: 'buttonRenderer'
          };

          if (params.data == null) {
            return null;
          } else {
            return buttonRenderer;
          }
        },
        cellRendererParams: {
          onClick: this.onDeleteClick.bind(this),
          label: 'Delete'
        }
      },

    ];
  }

  onDeleteClick(e) {
    const tempList = this.origDestDetails;
    for (let i = 0; i < this.origDestDetails.length; i++) {
      if (e.rowData.orgnDestId == this.origDestDetails[i].orgnDestId) {
        console.log('found');
        console.log(tempList);
        tempList.splice(i, 1);
        console.log(tempList);
        break;
      }
    }
    this.origDestDetails = tempList;
    this.gridApi.setGridOption('rowData', this.origDestDetails);
  }


  sroFormSave() {

    this.origDestLength = this.origDestDetails.length;
    if (this.origDestLength === null || this.origDestLength === undefined || this.origDestLength < 1) {
      this.alertService.error('There must be at least one origin/destination to save');
    } else {
      this.loader.show();
      const finalFormData: RatesSroMaster = new RatesSroMaster();
      finalFormData.sroMasterId = null;
      finalFormData.sroId = this.ratesSroMaintenanceSearchGroup.get('sroSearch').value;
      finalFormData.agencyMasterId = this.agencyMasterIdValue;
      finalFormData.agencyId = this.ratesSroMaintenanceSearchGroup.get('agencyBureauLocation').value;
      finalFormData.businessType = 'HHG';
      finalFormData.sroType = this.ratesSroMaintenanceSearchGroup.get('sroType').value;
      finalFormData.effectiveDate = this.ratesSroMaintenanceSearchGroup.get('effectiveDate').value;
      finalFormData.expiryDate = this.ratesSroMaintenanceSearchGroup.get('expiryDate').value;
      finalFormData.sroNotes = this.ratesSroMaintenanceSearchGroup.get('sroNotes').value;

      // Preparing for Rate Type value submission. Only one rate type can be selected for FRT,
      // but for HHG, multiple Rate types can be selected.
      const finalRateTypes: RateTypesSro[] = [];
      // this.rateTypeIdList = this.ratesSroMaintenanceSearchGroup.get('rateType').value;
      this.rateTypeIdList = this.assignedRateTypes;
      if (this.rateTypeIdList != null && this.rateTypeIdList.length > 0) {
        this.rateTypeIdList.forEach(rTypeId => {
          const tempRateType: RateTypesSro = new RateTypesSro();
          tempRateType.rateTypeId = rTypeId.rateTypeId;
          finalRateTypes.push(tempRateType);
        });
      }
      finalFormData.rateTypesSroEntity = finalRateTypes;


      // Preparing list for origin/destination combinations
      const finalOriginDestination: RatesSroOriginDestination[] = [];
      for (const origin of this.origDestDetails) {
        const originDestination: RatesSroOriginDestination = new RatesSroOriginDestination();
        originDestination.sroMasterId = null;
        originDestination.originId = origin.originId;
        originDestination.originCity = origin.originCity;
        originDestination.originZip = origin.originZip;
        originDestination.destinationId = origin.destinationId;
        originDestination.destinationCity = origin.destinationCity;
        originDestination.destinationZip = origin.destinationZip;
        for (const s of this.allStatesList) {
          if (s.stateCountryName === origin.originState) {
            originDestination.originState = s.stateCountryCode2Digit;
          }
          if (s.stateCountryName === origin.destinationState) {
            originDestination.destinationState = s.stateCountryCode2Digit;
          }
        }
        finalOriginDestination.push(originDestination);
      }
      finalFormData.ratesSroOriginDestinationEntity = finalOriginDestination;

      this.ratesSroMasterService.saveRatesSro(finalFormData).subscribe(() => {
        this.loader.hide();
        this.alertService.success('Successfully saved SRO record');
        this.clearForm();
        this.ratesSroMaintenanceSearchGroup.reset();
        this.ratesSroMaintenanceAddGroup.reset();
        this.loader.show();
        this.agencyMasterService.getAllAgency().subscribe(allAgencies => {
          this.agencyCustomerList = allAgencies;
          this.loader.hide();
        }, error => {
          this.loader.hide();
          this.alertService.error('There was an error retrieving agencyName List');
        });
      }, error => {
        this.loader.hide();
        this.alertService.error('There was an error saving SRO Details');
        this.deleteflag = true;
      });
    }
  }

  deleteSro() {
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.content.question = 'Are you Sure, Do You Want to Delete this SRO';
    this.modalRef.content.title = 'Deleting SRO Code ' + this.sroCode;
    this.modalRef.content.confirmText = 'Yes';
    this.modalRef.content.cancelText = 'No';
    this.modalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        this.loader.show();
        this.ratesSroMasterService.deleteRatesSro(this.sroMasterId).subscribe(() => {
          this.deleteSroButton = false;
          this.alertService.success('Successfully Deleted SRO');
          this.clearForm();
          this.ratesSroMaintenanceSearchGroup.reset();
          this.ratesSroMaintenanceAddGroup.reset();
          this.agencyMasterService.getAllAgency().subscribe(allAgencies => {
            this.agencyCustomerList = allAgencies;
            this.loader.hide();
          }, error => {
            this.loader.hide();
            this.alertService.error('There was an error retrieving agencyName List');
          });
        }, error => {
          this.loader.hide();
          this.alertService.error('There was an error deleting SRO');
        });
      }
    });
  }

  // This function is used to clear all the form values & set them to default
  clearForm() {
    this.sroOriginDestinationData = [];
    this.origDestDetails = [];
    this.disableAddOriginDestinationButton = true;
    this.ratesSroMaintenanceSearchGroup.controls['sroType'].disable();
    this.ratesSroMaintenanceSearchGroup.controls['bureauName'].disable();
    // this.ratesSroMaintenanceSearchGroup.controls['agencyBureauLocation'].disable();
    this.ratesSroMaintenanceSearchGroup.controls['sroCode'].disable();
    this.ratesSroMaintenanceSearchGroup.controls['rateType'].disable();
    this.resultsPage = [];
    this.assignedRateTypes = [];
    this.availRateTypesArray = [];
    this.disableAddOriginDestinationButton = true;
  }
  clearFormAll() {
    this.sroOriginDestinationData = [];
    this.origDestDetails = [];
    this.resultsPage = [];
    this.assignedRateTypes = [];
    this.availRateTypesArray = [];
    this.ratesSroMaintenanceSearchGroup.controls['sroSearch'].setValue(null);
    this.ratesSroMaintenanceSearchGroup.controls['sroType'].setValue(null);
    this.ratesSroMaintenanceSearchGroup.controls['agencyName'].setValue(null);
    this.ratesSroMaintenanceSearchGroup.controls['bureauName'].setValue(null);
    this.ratesSroMaintenanceSearchGroup.controls['agencyBureauLocation'].setValue(null);
    this.ratesSroMaintenanceSearchGroup.controls['sroCode'].setValue(null);
    this.ratesSroMaintenanceSearchGroup.controls['effectiveDate'].setValue(null);
    this.ratesSroMaintenanceSearchGroup.controls['expiryDate'].setValue(null);
    this.ratesSroMaintenanceSearchGroup.controls['rateType'].setValue(null);
    this.ratesSroMaintenanceSearchGroup.controls['sroNotes'].setValue(null);
    this.disableAddOriginDestinationButton = true;
  }
  moveItems() {
    const sourceArray = this.ratesSroMaintenanceSearchGroup.get('rateType').value;
    const rateTypeArray = [];
    const destinationArray = AppConstants.isNotNullCondition(this.assignedRateTypes) ? this.assignedRateTypes : [];
    this.rateTypes.forEach(e => {
      sourceArray.forEach(y => {
        const isPresent = destinationArray.find(x => x.rateTypeId === y);
        if (e.rateTypeId === y && !isPresent) {
          rateTypeArray.push(e);
        }
      });
    });
    this.assignedRateTypes = Array.from(new Set(destinationArray.concat(rateTypeArray)));
  }

  handleRateTypesMultiDropdown(i: any) {
      this.assignedRateTypes.splice(i, 1);
  }

  changeTypeaheadOriginLoading(e: boolean): void {
    this.typeaheadOriginLoading = e;
  }

  changeTypeaheadDestinationLoading(e: boolean): void {
    this.typeaheadDestinationLoading = e;
  }
  typeaheadDestinationOnSelect(e: TypeaheadMatch): void {
    this.ratesSroMaintenanceAddGroup.get('destinationId').setValue(e.item);
  }
  typeaheadOriginOnSelect(e: TypeaheadMatch): void {
    this.ratesSroMaintenanceAddGroup.get('originId').setValue(e.item);
  }
}
